import classNames from "classnames";
import { LoginType } from "../../../../models";
import { EIdActionItem } from "./eIdActionItem";

interface IEIdActionPickerProps {
  loading: boolean;
  isValid?: boolean;
  action: (loginType: LoginType) => void;
}

export function EIdActionPicker(props: Readonly<IEIdActionPickerProps>) {
  const { loading, action, isValid } = props;

  const imgClassName = classNames("avis-login-img", {
    disabled: loading || isValid === false,
  });
  const eIdClassname = classNames("eID", imgClassName);
  const eMobileClassname = classNames("eMobile", imgClassName);

  return (
    <div className="eparaksts-auth">
      <EIdActionItem
        className={eIdClassname}
        actionType="sc_plugin"
        loading={loading}
        onClick={action}
        isValid={isValid}
      />
      <EIdActionItem
        className={eMobileClassname}
        actionType="mobile"
        loading={loading}
        onClick={action}
        isValid={isValid}
      />
    </div>
  );
}
